import { IApplicationState } from '@bridebook/web/lib/types';
import { Events } from '@bridebook/models/source/models/Weddings/Events';
import { parseDate } from '@bridebook/web/lib/utils/parse-date';
import { ADD_GUEST_TO_MAIN_EVENT_BY_DEFAULT_ACTIVATE_DATE } from './constants';

/**
 * LIVE-25190 Auto add guests to main event
 * Only if there is only one event - if more than one event exists, don’t automatically add guests
 * Only for new weddings created after release using a timestamp
 */
export const getShouldAddGuestToMainEvent = (state: IApplicationState) =>
  !!state.weddings?.profile?.createdAt &&
  parseDate(state.weddings.profile.createdAt) > ADD_GUEST_TO_MAIN_EVENT_BY_DEFAULT_ACTIVATE_DATE &&
  state.weddingEvents.list.length === 1 &&
  state.weddingEvents.list[0].id === Events.MAIN_EVENT;

export const getWeddingEvents = (state: IApplicationState) => state.weddingEvents.list;
